<template>
  <span class="pl-1">
    <font-awesome-icon v-if="isAccomplished" :icon="['far', 'check']" class="text-success"/>
    <b-icon v-if="isAccomplished == false" icon="exclamation" variant="danger" animation="fade" scale="2"></b-icon>
  </span>
</template>

<script>
export default {
  name: "AccomplishmentIcon",
  props: {
    isAccomplished: {
      type: Boolean,
      default: undefined
    }
  }
}
</script>